<template>
  <v-app>
    <v-container>
      <v-row class="justify-center">
        <v-col class="col-12 col-md-12">
          <h2
            class="text-center text-md-left primary--text d-flex align-center"
            v-for="(icon, index) in items"
            :key="index"
          >
            <v-icon class="primary--text mr-2" size="32">{{ icon.icon }}</v-icon
            >{{ $t('navBar.coupon') }}
          </h2>
        </v-col>
      </v-row>
      <hr class="primary--lightGray mt-3" />
      <v-col class="col-12">
        <v-row>
          <p class="primary--lightGray schedule-text mt-3">
            {{ $t('navBar.description1') }}<br>
            {{ $t('navBar.description2') }}
            &nbsp;
            <router-link
              to="help"
            >
              suporte
            </router-link>
            &nbsp;
            {{ $t('navBar.description3') }}
          </p>
        </v-row>
      </v-col>
      <div v-if="!redoForm" style="position: relative">
        <div class="container-filter">
          <div align="center" style="width: 100%" justify="end">
            <div class="footer-filter">
              <div class="card-container-filter">
                <div class="card-filter" style="position: relative">
                  <img
                    class="filter-position"
                    :src="require('../../assets/cupom.svg')"
                  />
                  <v-text-field
                    hide-details
                    solo
                    v-model="name"
                    :label="$t('couponPage.searchByCouponName')"
                    prepend-inner-icon="filt"
                    background-color="#fff"
                  ></v-text-field>
                </div>
                <div class="card-filter" style="position: relative">
                  <img
                    class="filter-position"
                    style="height: 25px"
                    :src="require('../../assets/money.svg')"
                  />
                  <v-text-field
                    hide-details
                    solo
                    v-model="value"
                    label="Porcentagem"
                    prepend-inner-icon="filt"
                    background-color="#fff"
                  ></v-text-field>
                </div>
                <div class="card-filter">
                  <DatePicker
                    label="Data de validade"
                    :isFlat="false"
                    background="#fff"
                    :isRequired="false"
                    @date="saveDate($event)"
                  />
                </div>
                <div class="card-filter">
                  <v-select
                    hide-details
                    solo
                    :items="['Inativo', 'Ativo']"
                    label="Status"
                    v-model="status"
                  ></v-select>
                </div>
              </div>
              <div>
                <v-btn
                  color="primary"
                  class="
                    lato-black
                    white--text
                    text-transform-none
                    br-10
                    ml-md-5
                    mt-md-0
                  "
                  height="40"
                  width="140"
                  @click="clearForm"
                >
                  Limpar filtro
                </v-btn>
                <v-btn
                  color="secondary"
                  class="
                    lato-black
                    white--text
                    text-transform-none
                    br-10
                    ml-1 ml-md-5
                  "
                  height="40"
                  width="140"
                  @click="filterCoupons"
                >
                  Filtrar
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>

      <v-row>
        <v-row class="table-container">
          <v-simple-table>
            <template v-slot:default v-if="!placeholder">
              <thead>
                <tr>
                  <th
                    v-for="dessert in headers"
                    v-bind:key="dessert.value"
                    class="tc-header"
                  >
                    {{ dessert.text }}
                  </th>
                </tr>
              </thead>
              <tbody class="tc-body">
                <tr v-for="(coupon, index) in coupons" :key="coupon.id">
                  <td>{{ coupon.name }}</td>
                  <td id="couponValue">{{ coupon.coupon.value }}% OFF</td>
                  <td>{{ coupon.coupon.validate | formatDate }}</td>
                  <td>{{ coupon.coupon.use }}/{{ coupon.coupon_use }}</td>
                  <td>
                    <toggle-button
                      :value="coupon.activated"
                      color="#02A554"
                      :sync="true"
                      :labels="{ checked: 'Ativo', unchecked: 'Inativo' }"
                      width="65"
                      @change="
                        toggle(value, coupon.coupon.id, coupon.name, index)
                      "
                    />
                  </td>
                </tr>
              </tbody>
            </template>
            <div class="dataNotFound" v-if="placeholder">
              {{ $t('couponPage.couponNotFound') }}
            </div>
          </v-simple-table>
        </v-row>
      </v-row>

      <v-dialog
        ref="modal"
        v-model="modal"
        max-width="400px"
        class="dialog-consult"
      >
        <v-card class="dialog-consult">
          <header>
            <h1>O que você deseja fazer?</h1>
          </header>
          <section>
            <p>
              Ao ativar seus pacientes poderão utilizá-lo para obter desconto em
              qualquer consulta.
            </p>
          </section>
          <footer>
            <button @click="changeModal(false)">Desativar</button>
            <button @click="changeModal(true)">Ativar</button>
          </footer>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
// eslint-disable-next-line import/extensions
import DatePicker from '@/components/DatePicker';
import Api from '../../services/httpClient';

export default {
  data() {
    return {
      modal: false,
      coupons: [],
      couponsPsy: [],
      coupon_id: '',
      coupon_name: '',
      auxiliar: false,
      index: '',
      redoForm: false,
      placeholder: false,
      headers: [
        {
          text: 'Nome',
          value: 'cupão10show',
        },
        {
          text: 'Valor',
          value: 'pt_value',
        },
        {
          text: 'Validade',
          value: 'date',
        },
        {
          text: 'Uso',
          value: '0',
        },
        {
          text: 'Status',
          value: 'stripe_payment_value',
        },
      ],
      name: '',
      value: '',
      validate: '',
      status: '',
      items: [{ icon: 'fas fa-ticket-alt' }],
    };
  },

  components: {
    DatePicker,
  },

  created() {
    Api.get(`/coupons_psychologist/`, {
      headers: {
        Authorization: `Token ${localStorage.getItem('user-token')}`,
      },
    })
      .then((res) => {
        this.coupons = res.data;
        this.couponsPsy = res.data;
      })
      .catch((err) => console.log(err));
  },

  methods: {
    saveDate(dateValue) {
      this.validate = dateValue;
    },
    changeModal(choice) {
      Api.post(
        `/coupons_psychologist/`,
        {
          coupon: this.coupon_id,
          activated: choice,
        },
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      )
        .then((response) => {
          this.coupons[this.index].activated = choice;
        })
        .catch((err) => {
          console.log(err.response.data);
        }),
        (this.$refs.modal.$data.isActive = false);
    },

    toggle(ide, coupon_id, coupon_name, index) {
      this.$refs.modal.$data.isActive = true;
      this.coupon_id = coupon_id;
      this.coupon_name = coupon_name;
      this.index = index;
    },

    async filterCoupons() {
      this.placeholder = false;
      if (this.status == 'Ativo') {
        this.status = true;
      } else if (this.status == 'Inativo') {
        this.status = false;
      }
      try {
        const res = await Api.get('/search_coupons/', {
          params: {
            name: this.name,
            coupon__value: this.value,
            coupon__validate: this.validate,
            activated: this.status,
          },
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        });
        if (res.data == '') {
          this.placeholder = true;
          return;
        }
        this.coupons = [];
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < this.couponsPsy.length; j++) {
            if (res.data[i].id == this.couponsPsy[j].id) {
              this.coupons.push(this.couponsPsy[j]);
            }
          }
        }
      } catch (error) {
        return Promise.reject(error);
      }
    },

    clearForm() {
      this.placeholder = false;
      this.status = '';
      this.coupons = this.couponsPsy;
      this.redoForm = true;
      setTimeout(() => {
        this.name = '';
        this.validate = '';
        this.value = '';
        this.status = '';
        this.redoForm = false;
      }, 10);
    },
  },
};
</script>

<style lang="css" scoped>
.custom-radius {
  border-radius: 30px;
}

.custom-radius__tag {
  border-radius: 0 30px 30px 0;
}

.border-bottom {
  border-bottom: 1px solid #ccc;
}

.obs-text {
  font-size: 0.8rem;
}

.no-schedule {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: #02a55333;
  border-radius: 20px;
  border: 1px dashed #02a554;
}

.filter-position {
  width: 27px;
  z-index: 6;
  top: 14px;
  left: 10px;
  margin-right: 2px;
  position: absolute;
}
.v-data-table {
  width: 100%;
  margin: 50px 0px;
  border: 1px solid #e2e2e2;
  background: #fff;
  border-radius: 5px;
  margin-top: 120px !important;
}

.tc-header {
  font-size: 17px !important;
}
.tc-body > tr:nth-child(even) {
  background: #fff !important;
}
.tc-body > tr:nth-child(odd) {
  background: #f7f7f7 !important;
}
.tc-body tr {
  border: 0;
  cursor: pointer;
}
.tc-body tr td {
  font-size: 16px !important;
  color: #7a7a7a !important;
  border: 0px !important;
}
.tc-body tr td#couponValue {
  font-weight: 800;
}
.tc-body tr td:last-child {
  color: #47ad63 !important;
  font-weight: 500;
}

.footer-filter {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 0px;
  justify-content: space-between;
}

.footer-filter > div:first-child {
  width: 72.2% !important;
  display: flex;
}
.footer-filter > div:last-child button:first-child {
  margin-left: 0 !important;
}
.card-container-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-filter {
  margin-left: 20px;
}
.card-container-filter .card-filter:first-child {
  width: 50%;
  margin-left: 0px;
}

.container-filter {
  width: 100%;
  margin: 10px 0px;
  position: absolute;
  top: 0px;
  right: -24px;
}
.dialog-consult {
  padding: 40px 20px;
  background: #ededed;
}
.dialog-consult section {
  text-align: center;
}
.dialog-consult section p {
  color: #635e5e;
}
.dialog-consult footer {
  margin-top: 35px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.dialog-consult button {
  width: 120px;
  padding: 4px 8px;
  border-radius: 5px;
  font-weight: 600;
}

.dialog-consult button:first-child {
  background: transparent;
  color: #635e5e;
  border: 2px solid #635e5e;
}
.dialog-consult button:last-child {
  background: #45a655;
  color: #fff;
}
.dialog-consult h1 {
  color: #45a655;
  font-size: 20px;
  text-align: center;
  margin-bottom: 15px;
}
.dataNotFound {
  height: 60px;
  font-size: 1.2rem;
  color: #7a7a7a;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 1172px) {
  .table-container {
    padding: 0 0.5rem;
    overflow-x: scroll;
  }
  .tc-body tr td {
    font-size: 12px !important;
    color: #7a7a7a !important;
    border: 0px !important;
  }
  .tc-header {
    font-size: 12px !important;
  }
  .footer-filter {
    width: 100% !important;
    max-width: 670px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .card-filter {
    width: 100%;
    margin: 10px 0px !important;
  }
  .footer-filter > div:first-child {
    width: inherit !important;
    display: flex;
    flex-direction: column;
  }
  .footer-filter > div:last-child {
    margin-top: 25px;
  }
  .card-container-filter .card-filter:first-child {
    width: 100% !important;
  }
  .container-filter {
    right: 0;
    position: inherit;
  }
  .v-data-table {
    margin-top: 50px;
  }
  .dataNotFound {
    font-size: 1rem;
    width: 80%;
    margin: auto;
  }
}
</style>
